// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".see_more-module__seeMore--3exOc{font-weight:600;font-size:16px;line-height:24px;letter-spacing:0px;color:#36b;cursor:pointer;margin:0}.see_more-module__seeMore--3exOc:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"seeMore": "see_more-module__seeMore--3exOc"
};
module.exports = exports;
